// src/components/ui/Star.jsx
import React, { useId } from 'react';

const STAR_PATH =
  'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

const STAR_COLOR = '#f59e0b';

const Star = ({ filled = false, half = false, size = 14 }) => {
  const clipId     = useId();
  const showHalf   = !filled && half;
  const showFilled = filled && !half;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0 }}
    >
      {showHalf && (
        <defs>
          <clipPath id={clipId}>
            <rect x="0" y="0" width="12" height="24" />
          </clipPath>
        </defs>
      )}

      {/* Outline — always visible */}
      <path d={STAR_PATH} fill="none" stroke={STAR_COLOR} strokeWidth="1.2" strokeLinejoin="round" />

      {/* Full fill */}
      {showFilled && <path d={STAR_PATH} fill={STAR_COLOR} />}

      {/* Half fill */}
      {showHalf && <path d={STAR_PATH} fill={STAR_COLOR} clipPath={`url(#${clipId})`} />}
    </svg>
  );
};

export default Star;